import { render, staticRenderFns } from "./Dialogs.vue?vue&type=template&id=4160a358&scoped=true&"
import script from "./Dialogs.vue?vue&type=script&lang=js&"
export * from "./Dialogs.vue?vue&type=script&lang=js&"
import style0 from "./Dialogs.vue?vue&type=style&index=0&id=4160a358&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4160a358",
  null
  
)

export default component.exports